var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrying(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 215,
    viewBox: "0 0 196 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_222_37549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.663 37.793H155.719V66.892H162.663V37.793Z",
    fill: "#3E6E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.191 0L139.43 39.515H178.945L159.191 0Z",
    fill: "#3E6E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.945 55.9722H172.001V85.0712H178.945V55.9722Z",
    fill: "#E86641"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.473 122.871L155.719 83.356H195.227L175.473 122.871Z",
    fill: "#E86641"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0577 156.282C90.1217 156.282 84.4587 155.428 79.0687 153.734C73.6787 152.033 69.3527 149.842 66.0977 147.168L70.9836 136.206C74.0216 138.593 77.7875 140.588 82.2747 142.177C86.7617 143.773 91.3537 144.564 96.0577 144.564C100.034 144.564 103.254 144.13 105.718 143.262C108.175 142.394 109.988 141.218 111.143 139.734C112.298 138.25 112.879 136.57 112.879 134.687C112.879 132.37 112.046 130.508 110.38 129.094C108.714 127.68 106.565 126.56 103.919 125.727C101.273 124.894 98.3467 124.138 95.1267 123.445C91.9067 122.759 88.6867 121.912 85.4667 120.897C82.2466 119.882 79.2997 118.601 76.6187 117.04C73.9377 115.486 71.7886 113.407 70.1576 110.796C68.5266 108.192 67.7147 104.86 67.7147 100.807C67.7147 96.7539 68.8137 92.9039 71.0257 89.4669C73.2307 86.0299 76.5977 83.2789 81.1197 81.2139C85.6417 79.1489 91.3747 78.1199 98.3257 78.1199C102.883 78.1199 107.405 78.7009 111.892 79.8559C116.379 81.0179 120.285 82.6769 123.617 84.8469L119.165 95.8089C115.763 93.7859 112.256 92.2809 108.637 91.3009C105.018 90.3209 101.546 89.8379 98.2137 89.8379C94.3777 89.8379 91.2277 90.3069 88.7707 91.2519C86.3067 92.1899 84.5217 93.4429 83.3947 94.9969C82.2747 96.5509 81.7147 98.2729 81.7147 100.156C81.7147 102.473 82.5267 104.335 84.1577 105.749C85.7887 107.163 87.9167 108.262 90.5627 109.06C93.2017 109.858 96.1557 110.614 99.4107 111.342C102.666 112.063 105.886 112.917 109.071 113.89C112.256 114.87 115.182 116.137 117.863 117.691C120.537 119.245 122.693 121.31 124.324 123.879C125.955 126.448 126.767 129.724 126.767 133.7C126.767 137.676 125.661 141.498 123.456 144.935C121.244 148.372 117.863 151.123 113.306 153.188C108.749 155.253 102.995 156.282 96.0437 156.282H96.0577ZM92.6907 168.224V66.1919H101.595V168.224H92.6907Z",
    fill: "url(#paint0_linear_222_37549)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.1836 28.015C46.0796 28.1549 5.50684 68.8139 5.50684 118.951L5.5 118.951C5.5 169.174 46.2127 209.887 96.436 209.887C146.659 209.887 187.372 169.174 187.372 118.951H192.372C192.372 171.936 149.421 214.887 96.436 214.887C43.4513 214.887 0.5 171.936 0.5 118.951L0.506836 118.951C0.506836 65.966 43.4582 23.0146 96.4429 23.0146V23.0223C106.503 23.0497 115.173 24.6659 121.346 26.2814C124.462 27.0968 126.949 27.9142 128.669 28.5322C129.528 28.8413 130.197 29.1008 130.656 29.2856C130.885 29.378 131.063 29.4518 131.186 29.5038C131.247 29.5298 131.295 29.5504 131.329 29.5651L131.37 29.5828L131.383 29.5883L131.387 29.5901L131.388 29.5909C131.389 29.5912 131.39 29.5914 130.379 31.878C129.368 34.1645 129.369 34.1647 129.369 34.1649L129.367 34.1639L129.345 34.1544L129.322 34.1446C129.301 34.1356 129.274 34.1239 129.239 34.1094C129.142 34.0683 128.991 34.0055 128.789 33.9241C128.385 33.7613 127.775 33.5242 126.977 33.2375C125.381 32.6637 123.036 31.8921 120.08 31.1185C114.163 29.57 105.831 28.022 96.1836 28.022V28.015Z",
    fill: "url(#paint1_linear_222_37549)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_222_37549",
    x1: 66.1051,
    y1: 117.238,
    x2: 126.768,
    y2: 117.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_222_37549",
    x1: 0.523587,
    y1: 119.008,
    x2: 192.374,
    y2: 119.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_222_37549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 215,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrying);
export default __webpack_public_path__ + "static/media/trying.2029485f36a98776896877ab0f2f0315.svg";
export { ForwardRef as ReactComponent };